<template>
  <div
    :class="classes(n())"
    :style="containerStyle"
  >
    <div :class="classes(n('currency'))">
      {{ currencyCode }}
    </div>
    <div :class="classes(n('amount'))">
      {{ displayAmount }}
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { props, DEFAULT_AMOUNT_BOX_SIZE } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { fen2Yuan } from '@tencent/wphk-utils';

const { name, n, classes } = createNamespace('amount-box');

export default defineComponent({
  name,
  props,
  emits,
  setup(props) {
    // 计算格式化后的金额
    const displayAmount = computed(() => {
      const yuan = fen2Yuan(props.value || 0);
      return Number.parseFloat(yuan).toFixed(Math.max(props.bit, 0));
    });
    const containerStyle = computed(() => ({
      '--amount-size-scale': (props.size) / DEFAULT_AMOUNT_BOX_SIZE,
    }));

    return {
      n,
      classes,
      displayAmount,
      containerStyle,
    };
  },
});
</script>
